<template>
  <div class="searchform">
    <div class="my-4 border-bottom pb-3">
      <h2 class="display-4">Search Results</h2>
    </div>

    <div class="row my-4">
      <div class="col-md-8">
        <div v-for="post in posts" style="position:relative;">
          <h3 v-html="post.title.rendered">{{ post.title.rendered }}</h3>
          <div class="text-muted mb-2">{{ post.date | moment("dddd, MMMM D, YYYY") }} at {{ post.date | moment("h:mm a") }}</div>
          <div v-html="post.excerpt.rendered">{{ post.excerpt.rendered }}</div>
          <router-link :to="{ name: 'post', params: { slug: post.slug }}" class="stretched-link">Continue reading</router-link>

          <hr>
        </div>
      </div>
      <div class="col-md-4">
        <NewsletterSignUp />
        <SearchForm />
        <CardShareNoteNews />
      </div>
    </div>

    <div class="sn-c-spinner__background" v-if="loading">
      <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border sn-c-spinner" role="status">
              <span class="sr-only">Loading...</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
//import CategoryPosts from '@/components/CategoryPosts.vue';
import NewsletterSignUp from '@/components/NewsletterSignUp.vue';
import SearchForm from '@/components/SearchForm.vue';
import CardShareNoteNews from '@/components/CardShareNoteNews.vue';

export default {
  name: 'search',
  components: {
    NewsletterSignUp,
    SearchForm,
    CardShareNoteNews
  },
  data() {
    return {
      posts: [],
      errors: [],
      loading: false
    }
  },
  watch: {
    '$route': 'getSearchResults'
  },
  methods: {
    getSearchResults() {
      axios.get('https://wpapi.sharenote.com/wp-json/wp/v2/posts?per_page=10&search=' + this.$route.params.search + '&categories=1')
      .then(response => {
        // JSON responses are automatically parsed.
        this.posts = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  },
  mounted() {
    this.getSearchResults();
  }
}
</script>
